module.exports = __webpack_public_path__ + "img/galvanized_galvalume_sheets.3ef6b291.jpg";